<template>
  <el-dialog title="选择权益" :visible.sync="dialogVisible" width="1100px" @close="handleClose">
    <div class="add-equity-container">
      <!-- 搜索表单 -->
      <div class="new-top-bg-box new-input-box">
        <el-form :model="searchForm" :inline="true" class="search-form">
          <el-form-item label="权益名称">
            <el-input v-model="searchForm.name" placeholder="请输入权益名称" clearable></el-input>
          </el-form-item>
          <el-form-item label="最后修改时间">
            <el-date-picker v-model="dateRange" type="daterange" range-separator="至" start-placeholder="开始日期"
              end-placeholder="结束日期" value-format="yyyy-MM-dd" @change="handleDateChange">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleSearch">查询</el-button>
            <el-button @click="resetForm">重置</el-button>
          </el-form-item>
        </el-form>
      </div>

      <!-- 表格 -->
      <div class="new-bottom-bg-box table-box new-input-box">
        <el-table ref="multipleTable" :data="tableData" v-loading="loading" @selection-change="handleSelectionChange"
          style="border: 1px solid #eeeeee;margin-top:20px;" :header-cell-style="{
            background: '#FAFAFA',
            'text-align': 'left',
          }">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column label="权益图标" min-width="150">
            <template slot-scope="scope">
              <img class="benefit-icon" :src="scope.row.benefitEnableIconUrl" />
            </template>
          </el-table-column>
          <el-table-column label="权益名称" prop="name" min-width="150">
            <template slot-scope="scope">
              {{ scope.row.name || "-" }}
            </template>
          </el-table-column>
          <el-table-column label="跳转链接" prop="jumpInfo" min-width="200">
            <template slot-scope="scope">
              <el-tooltip class="item" effect="dark" :content="scope.row.jumpInfo || '-'" placement="top" :disabled="!scope.row.jumpInfo || scope.row.jumpInfo.length < 30">
                <div class="ellipsis-text">{{ scope.row.jumpInfo || "-" }}</div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column label="最后修改时间" prop="updateTime" min-width="180">
            <template slot-scope="scope">
              {{ scope.row.updateTime || "-" }}
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="pagination.pageNum" :page-sizes="[10, 20, 50, 100]" :page-size="pagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>

      <div class="add-link">
        <a href="javascript:;" style="color: #3159ff" @click="goToAddEquity">去添加权益></a>
      </div>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleConfirm">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getMemberBenefitInfo } from "@/api/paradiseAndTaskCommonController.js";

export default {
  name: 'AddEquity',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    // 已选择的权益列表
    selectedEquities: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      dialogVisible: false,
      searchForm: {
        name: '',
        updateStartTime: '',
        updateEndTime: ''
      },
      dateRange: [],
      tableData: [],
      loading: false,
      pagination: {
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      // 当前选中的权益
      selectedRows: [],
      // 存储所有已选择的权益（包括临时选择和父组件传入的）
      allSelectedEquities: []
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val;
      if (val) {
        // 初始化时，将父组件传入的已选择权益复制到临时存储中
        this.allSelectedEquities = [...this.selectedEquities];
        this.getEquityList();
      } else {
        // 关闭弹窗时清空选择
        this.selectedRows = [];
        this.allSelectedEquities = [];
        if (this.$refs.multipleTable) {
          this.$refs.multipleTable.clearSelection();
        }
      }
    },
    selectedEquities: {
      handler(val) {
        if (this.dialogVisible && this.$refs.multipleTable && this.tableData.length > 0) {
          // 更新临时存储
          this.allSelectedEquities = [...val];
          this.$nextTick(() => {
            this.setSelectedRows();
          });
        }
      },
      deep: true
    }
  },
  methods: {
    // 处理日期变化
    handleDateChange(val) {
      if (val) {
        this.searchForm.updateStartTime = val[0];
        this.searchForm.updateEndTime = val[1];
      } else {
        this.searchForm.updateStartTime = '';
        this.searchForm.updateEndTime = '';
      }
    },

    // 搜索
    handleSearch() {
      this.pagination.pageNum = 1;
      this.getEquityList();
    },

    // 重置表单
    resetForm() {
      this.searchForm = {
        name: '',
        updateStartTime: '',
        updateEndTime: ''
      };
      this.dateRange = [];
      this.pagination.pageNum = 1;
      this.getEquityList();
    },

    // 获取权益列表
    getEquityList() {
      this.loading = true;
      let params = {
        name: this.searchForm.name,
        updateStartTime: this.searchForm.updateStartTime || "",
        updateEndTime: this.searchForm.updateEndTime || "",
        current: this.pagination.pageNum,
        size: this.pagination.pageSize,
      }
      // 获取权益列表
      getMemberBenefitInfo(params).then(res => {
        this.loading = false;
        console.log("--- res:---", res)
        if (res.code == 200 || res.code === 1) {
          this.tableData = res.data.records || [];
          this.total = Number(res.data.total);
          this.$nextTick(() => {
            this.setSelectedRows();
          });
        } else {
          this.$message.error(res.message);
        }
      }).catch(err => {
        this.loading = false;
      })
    },

    // 设置已选中的权益
    setSelectedRows() {
      // 先清除所有选择
      if (this.$refs.multipleTable) {
        this.$refs.multipleTable.clearSelection();
      }

      this.selectedRows = [];

      if (!this.tableData || this.tableData.length === 0) {
        return;
      }

      // 遍历表格数据，找出已选择的项目
      this.$nextTick(() => {
        this.tableData.forEach(row => {
          // 使用id和name双重匹配，提高匹配准确性
          const isSelected = this.allSelectedEquities.some(item =>
            (item.id === row.id) || (item.name === row.name && item.name)
          );

          if (isSelected) {
            // 将已选项添加到选中数组
            this.selectedRows.push(row);
            // 设置表格行选中状态
            this.$refs.multipleTable.toggleRowSelection(row, true);
          }
        });
        console.log("--- 已选择的权益: ---", this.selectedRows);
      });
    },

    // 处理页码变化
    handleCurrentChange(currentPage) {
      // 在翻页前保存当前选择
      this.saveCurrentSelections();
      
      this.pagination.pageNum = currentPage;
      this.getEquityList();
    },

    // 处理每页显示条数变化
    handleSizeChange(size) {
      // 在改变每页显示数量前保存当前选择
      this.saveCurrentSelections();
      
      this.pagination.pageSize = size;
      this.pagination.pageNum = 1;
      this.getEquityList();
    },

    // 保存当前页的选择到临时存储
    saveCurrentSelections() {
      // 先从临时存储中移除当前页的数据（避免重复）
      if (this.tableData && this.tableData.length > 0) {
        this.tableData.forEach(row => {
          const index = this.allSelectedEquities.findIndex(item => 
            (item.id === row.id) || (item.name === row.name && item.name)
          );
          if (index !== -1) {
            this.allSelectedEquities.splice(index, 1);
          }
        });
      }
      
      // 将当前选中的行添加到临时存储
      if (this.selectedRows && this.selectedRows.length > 0) {
        this.allSelectedEquities = [...this.allSelectedEquities, ...this.selectedRows];
      }
    },

    // 选择变化
    handleSelectionChange(val) {
      this.selectedRows = val;
    },

    // 去添加权益
    goToAddEquity() {
      // 跳转到添加权益页面或打开添加权益弹窗
      window.open('/integralCenter/integralCenter/memberShipLevel');
    },

    // 关闭弹窗
    handleClose() {
      this.$emit('update:visible', false);
      this.$emit('close');
    },

    // 确认选择
    handleConfirm() {
      // 在确认前保存当前页的选择
      this.saveCurrentSelections();
      
      // 最多选择20个
      if (this.allSelectedEquities.length > 20) {
        this.$message.warning("最多只能选择20个权益");
        return;
      }
      console.log("--- 确认选择的权益:---", this.allSelectedEquities);
      this.$emit('confirm', this.allSelectedEquities);
      this.handleClose();
    }
  }
}
</script>

<style scoped>
.add-equity-container {
  padding: 0 10px;
}

.add-link {
  cursor: pointer;
  margin-top: 16px;
  text-align: right;
  position: absolute;
  right: 24px;
  top: 138px;
}

.benefit-icon {
  width: 50px;
  height: 50px;
}

.new-top-bg-box {
  margin-bottom: 0px;
  padding-bottom: 0px !important;
  padding-left: 0;
  padding-top: 0;
}

.new-bottom-bg-box {
  border-radius: 8px;
}

.search-form {
  padding: 15px 0;
}

.ellipsis-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 180px;
  display: inline-block;
}
</style>